/* eslint-disable react/no-unknown-property */
// 输入框选择框样式
export const InputStyle = {
  "& label.Mui-focused": {
    color: "#505259",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#E0E3E7",
    },
    "&.Mui-focused fieldset": {
      borderWidth: "1px",
      borderColor: "#1a1a1a",
      borderStyle: "solid",
    },
  },
  "& .MuiFormControl-root": {
    "& fieldset": {
      borderColor: "#E0E3E7",
    },
    "&.Mui-focused fieldset": {
      borderWidth: "1px",
      borderColor: "#1a1a1a",
      borderStyle: "solid",
    },
  },
};

export const BoxStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const avatarUploadIcon = (
  <svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.1714 5.20616L11.9935 4.51906V4.51906L13.1714 5.20616ZM11.1042 8.75V10.1136H11.8874L12.282 9.4371L11.1042 8.75ZM30.8958 8.75L29.718 9.4371L30.1126 10.1136H30.8958V8.75ZM28.8286 5.20616L27.6507 5.89325L27.6507 5.89325L28.8286 5.20616ZM14.3493 5.89325C15.0824 4.63645 16.4279 3.86364 17.8829 3.86364V1.13636C15.4579 1.13636 13.2154 2.42439 11.9935 4.51906L14.3493 5.89325ZM12.282 9.4371L14.3493 5.89325L11.9935 4.51906L9.92629 8.0629L12.282 9.4371ZM9.52273 10.1136H11.1042V7.38636H9.52273V10.1136ZM3.61364 16.0227C3.61364 12.7592 6.25923 10.1136 9.52273 10.1136V7.38636C4.753 7.38636 0.886364 11.253 0.886364 16.0227H3.61364ZM3.61364 28.9773V16.0227H0.886364V28.9773H3.61364ZM9.52273 34.8864C6.25923 34.8864 3.61364 32.2408 3.61364 28.9773H0.886364C0.886364 33.747 4.753 37.6136 9.52273 37.6136V34.8864ZM32.4773 34.8864H9.52273V37.6136H32.4773V34.8864ZM38.3864 28.9773C38.3864 32.2408 35.7408 34.8864 32.4773 34.8864V37.6136C37.247 37.6136 41.1136 33.747 41.1136 28.9773H38.3864ZM38.3864 16.0227V28.9773H41.1136V16.0227H38.3864ZM32.4773 10.1136C35.7408 10.1136 38.3864 12.7592 38.3864 16.0227H41.1136C41.1136 11.253 37.247 7.38636 32.4773 7.38636V10.1136ZM30.8958 10.1136H32.4773V7.38636H30.8958V10.1136ZM27.6507 5.89325L29.718 9.4371L32.0737 8.0629L30.0065 4.51906L27.6507 5.89325ZM24.1171 3.86364C25.5721 3.86364 26.9176 4.63646 27.6507 5.89325L30.0065 4.51906C28.7846 2.42439 26.5421 1.13636 24.1171 1.13636V3.86364ZM17.8829 3.86364H24.1171V1.13636H17.8829V3.86364Z"
      fill="white"
    />
    <rect
      x="14.2386"
      y="15.1136"
      width="13.5227"
      height="13.5227"
      rx="6.76136"
      stroke="white"
      strokeWidth="2.72727"
    />
    <rect x="31" y="13.75" width="3.125" height="3.125" rx="1.5625" fill="white" />
  </svg>
);
